<template>
    <router-link :to="productCollectionDate.url" class="rn-collection-inner-one">
        <div class="collection-wrapper relative p-4 bg-[var(--background-color-1)] rounded-md">
            <div class="collection-big-thumbnail overflow-hidden rounded-md">
                <img :src="productCollectionDate.thumbnail" alt="Nft_Profile" class="rounded-md object-cover w-full h-auto transition-transform duration-300 hover:scale-110">
            </div>
            <div class="collenction-small-thumbnail flex justify-between -mx-1 mt-1">
                <img :src="thumbnail.image"
                     v-for="(thumbnail, index) in productCollectionDate.smallThumbnails"
                     :key="`thumbnail-${index}`"
                     alt="Nft_Profile"
                     class="inline-block w-1/3 p-1 rounded-lg">
            </div>
            <div class="collection-profile absolute top-[48%] left-1/2 transform -translate-x-1/2">
                <img :src="productCollectionDate.client" alt="Nft_Profile" class="max-w-[80px] h-20 rounded-full border-[5px] border-[var(--color-primary-alta)] transition-transform">
            </div>
            <div class="collection-deg flex mt-4 justify-between items-center">
                <h6 class="title font-normal transition-colors hover:text-primary m-0">{{ productCollectionDate.title }}</h6>
                <span class="items px-2 py-1 bg-[var(--color-primary-alta)] rounded text-white text-sm transition-colors hover:bg-[var(--color-primary)]">{{ productCollectionDate.items }} Items</span>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'ProductCollectionCard',
        props: {
            productCollectionDate: {}
        }
    }
</script>